import { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./Button.module.scss";

type ButtonSize = "small" | "medium" | "large";
type ButtonType = "primary" | "secondary";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: ButtonSize;
  variant?: ButtonType;
  children: ReactNode;
}

const Button = ({
  size = "medium",
  variant = "primary",
  children,
  disabled,
  className,
  ...props
}: ButtonProps) => {
  const sizeClass = styles[size];
  const variantClass = styles[variant];
  const disabledClass = disabled ? styles.disabled : "";

  return (
    <button
      className={`${styles.button} ${sizeClass} ${variantClass} ${disabledClass} ${className || ""}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
